import { route, tag, type PageTour } from '../pageTour';

export const attendancePresenceTour: PageTour = {
  id: 'page-attendance-presence',
  version: 1,
  title: 'Presence',
  summary: 'Who is on site right now, and who hasn\'t arrived.',
  match: route('/attendance/presence'),
  steps: [
    {
      target: tag('attendance-presence-date'),
      title: 'Work date',
      description: 'Shows today by default. Pick an earlier date to see who came in that day.',
      side: 'right',
    },
    {
      target: tag('attendance-stats'),
      title: 'Today at a glance',
      description: 'How many employees are in the office, present or absent. Click a tile to list only those people.',
      side: 'bottom',
    },
    {
      target: tag('attendance-toolbar'),
      title: 'Count and refresh',
      description: 'See how many employees are listed, change rows per page, or refresh for the latest sightings.',
      side: 'bottom',
    },
    {
      target: tag('attendance-table'),
      title: 'Presence board',
      description: 'Each employee\'s status, first in, last out and time inside. Click a row to open their attendance record.',
      side: 'top',
    },
  ],
};
